import CartIcon from "~/assets/icons/CartIcon"
import Logo from "~/assets/icons/Logo"
import UserIcon from "~/assets/icons/UserIcon"
import CartBadge from "~/rs-components/global/header/CartBadge.client"
import TrustPilotManagement from "~/rs-components/home/TrustPilotManagement.client"
import { CustomerMetafields } from "~/types"
import { trustPilotCustomSetting, trustPilotTop } from "../settings"
import { isNonTransactional } from "../settings/__nonTransactional"
import { isKiosk } from "../settings/__product"
import TrustPilotCustom from "./TrustPilotCustom.client"
import IconMenu from "~/assets/icons/MenuIcon"


type SetupMobileHeaderProps = {
    openMenu: () => void,
    openCart: () => void,
    customer?: CustomerMetafields,
}

export default function SetupMobileHeader({ openMenu, openCart, customer }: SetupMobileHeaderProps) {
    return (
        <>
            <header role="banner" className="headerResponsive flex lg:hidden items-center h-nav backdrop-blur-lg z-40 top-0 justify-between w-full leading-none gap-4 px-4 md:px-8">
                <div className="headerResponsive__menuArea flex items-center justify-start w-full gap-4">
                    <button onClick={openMenu} className="relative flex items-center justify-center w-8 h-8">
                        <IconMenu />
                    </button>
                </div>

                <span
                    className="headerResponsive__logoArea flex items-center self-stretch leading-[3rem] md:leading-[4rem] justify-center flex-grow w-full h-full">
                    <a href="https://www.rosevears.co.uk/">
                        <Logo />
                    </a>
                </span>

                <div className="headerResponsive__cartArea flex items-center justify-end w-full gap-4">
                    {!isKiosk &&
                        <>
                            <div className="headerResponsive_UserIcon">
                                <a href='/account'><UserIcon /></a>
                            </div>
                            {!isNonTransactional &&
                                <button onClick={openCart} className="relative flex items-center justify-center w-8 h-8">
                                    <CartIcon />
                                    <CartBadge />
                                </button>
                            }
                        </>
                    }

                </div>

            </header >
            <div className="headerResponsive-trust-pilot-menu">
                {trustPilotCustomSetting.header.mobile ? <TrustPilotCustom testimonials={true}></TrustPilotCustom> : <></>}

                {trustPilotTop.visibility && trustPilotTop.position == 1 &&
                    <div className="trustPilotMenu">
                        <TrustPilotManagement type={0}></TrustPilotManagement>
                    </div>
                }
            </div>
        </>
    )
}